import {CommonModule} from '@angular/common';
import {MatButtonModule, MatDialogModule} from '@angular/material';
import {CommonDialogNotificationComponent} from './common-dialog-notification.component';
import {CommonDialogNotificationService} from './common-dialog-notification.service';
import {NgModule} from '@angular/core';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  declarations: [
    CommonDialogNotificationComponent
  ],
  exports: [CommonDialogNotificationComponent],
  entryComponents: [CommonDialogNotificationComponent],
  providers: [CommonDialogNotificationService]
})
export class CommonDialogNotificationModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/common-dialog-notification/common-dialog-notification.module.ts